module.exports = __webpack_public_path__ + "static/media/pexels-cottonbro-4620624 (1).98f9b96b.jpg";